import React from "react";
/*import ExpandLessIcon from "@material-ui/icons/ExpandLess";*/
//import { Swiper, SwiperSlide } from "swiper/react";
//import { Pagination } from "swiper";
import logo1 from "../Assets/Logos/Home/Planta Güemes.png";
import logo2 from "../Assets/Logos/Home/CN Sima.png";
// import logo3 from "../Assets/Logos/Home/Estaciones.png"; // YPF El Chango + Las Lajitas (El Chango ya no es parte del grupo)
import logo3 from "../Assets/Logos/Home/EstacionesLajitasTartagal.png";
import logo4 from "../Assets/Logos/Home/Combustibles.png";
import logo5 from "../Assets/Logos/Home/Neca.png";
import logo6 from "../Assets/Logos/Home/LogoVexenGris.png";
// import logo8 from "../Assets/Logos/Home/Logistica.png";
import logo9 from "../Assets/Logos/Home/Gas del Norte.png";
// import logo10 from "../Assets/Logos/Home/Puesto El Mollar.png";
import { Homecomponente } from "../Components/HomeComponente";
//import carru1 from "../Assets/redi1.png";
//import carru2 from "../Assets/redi2.png";
//import carru3 from "../Assets/redi3.png";
//import carru4 from "../Assets/redi4.png";
//import carru5 from "../Assets/redi5.png";
//import carru6 from "../Assets/redi6.png";
import { Helmet } from "react-helmet";
import { FaFacebook, FaLinkedin, FaYoutube } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
//import videoSource from "../Assets/Home Cn web v3 .mp4";
//import videoSource1 from "../Assets/Home-Cn-web-v3-.av1.mp4";
import { useTranslation } from "react-i18next";
//import Slider from "./Slider";
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import NAVBAR from "./NavBarNueva";
import NAVBARMOBILE from "./NavBarMobile";
import "./Home.css";
import FlechaScrol from "../Assets/flecha web cn grupo@300x-8.png";

const Home = () => {
  // eslint-disable-next-line no-unused-vars
  const [t, i18next] = useTranslation("global");
  // const [activeSlide, setActiveSlide] = useState(1);
  // const CustomPagination = ({ totalSlides, activeSlide }) => {
  //   return (
  //     <div className="custom-paginationHome">
  //       {[...Array(totalSlides)].map((_, index) => (
  //         <div
  //           key={index}
  //           className={`pagination-pointHome ${
  //             index + 1 === activeSlide ? "active" : ""
  //           }`}
  //         />
  //       ))}
  //     </div>
  //   );
  // };

  // Fila de arriba: 4 logos; fila de abajo: 3 logos intercalados con los de arriba
  const businessLogos = [
    {
      href: "https://cn-grupo.com/combustiblesdelnorte",
      src: logo4,
      alt: "Combustibles del Norte",
    },
    {
      href: "https://cn-grupo.com/cnsima",
      src: logo2,
      alt: "CN SIMA",
    },
    {
      href: "https://cn-grupo.com/gasdelnorte",
      src: logo9,
      alt: "Gas del Norte",
    },
    {
      href: "https://cn-grupo.com/plantaguemes",
      src: logo1,
      alt: "CN Planta Güemes",
    },
    {
      href: "https://cn-grupo.com/neca",
      src: logo5,
      alt: "NECA",
    },
    {
      href: "https://cn-grupo.com/estaciones",
      src: logo3,
      alt: "Estaciones de Servicio",
    },
    {
      href: "https://cn-grupo.com/vexen",
      src: logo6,
      alt: "Vexen",
    },
    // Empresas discontinuadas (se deja el código por si vuelven)
    // {
      // href: "https://cn-grupo.com/logistica",
      // src: logo8,
      // alt: "CN Logistica",
    // },
    // {
      // href: "https://cn-grupo.com/mollar",
      // src: logo10,
      // alt: "Puesto El Mollar",
    // },
  ];

  const businessLogoRows = [
    businessLogos.slice(0, 4),
    businessLogos.slice(4),
  ];

  // const handleSlideChange = (swiper) => {
  //   setActiveSlide(swiper.activeIndex + 1);
  // };

  return (
    <div className="home-container">
      <Helmet>
        {/* Título y descripción básicos */}
        <title>CN-GRUPO</title>
        <meta
          name="description"
          content="Somos un grupo empresarial con más de 35 años de trayectoria, que integra soluciones para los sectores de Oil & Gas, Agro y Minería. Desde cada una de nuestras unidades de negocio acompañamos el crecimiento de nuestros clientes con innovación, eficiencia y una visión de desarrollo sostenible."
        />

        {/* Open Graph / Facebook Meta Tags */}
        <meta property="og:type" content="business.business" />
        <meta property="og:title" content="CN-GRUPO" />
        <meta
          property="og:site_name"
          content="CN-GRUPO"
        />
        <meta property="og:url" content="https://cn-grupo.com" />
        <meta
          property="og:description"
          content="Somos un grupo empresarial con más de 35 años de trayectoria, que integra soluciones para los sectores de Oil & Gas, Agro y Minería. Desde cada una de nuestras unidades de negocio acompañamos el crecimiento de nuestros clientes con innovación, eficiencia y una visión de desarrollo sostenible."
        />
        <meta
          property="og:image"
          content="https://cn-grupo.com/LogoGasdelNorteSA.png"
        />

        {/* Información del negocio para Meta */}
        <meta
          property="business:contact_data:street_address"
          content="Avda.Chile 175"
        />
        <meta property="business:contact_data:locality" content="Salta" />
        <meta property="business:contact_data:region" content="Salta" />
        <meta property="business:contact_data:postal_code" content="4400" />
        <meta
          property="business:contact_data:country_name"
          content="Argentina"
        />
        <meta property="business:contact_data:cuit" content="30-70823944-1" />
        <meta
          property="business:contact_data:phone_number"
          content="+54 3874236555"
        />
        <meta
          property="business:contact_data:website"
          content="https://cn-grupo.com"
        />

        {/* Meta tags adicionales */}
        <meta name="author" content="CN Grupo" />
        <meta name="geo.region" content="AR-A" />
        <meta name="geo.placename" content="Salta" />
        <meta
          name="geo.position"
          content="-65.41651339151728, -24.804615680399422"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Gas del Norte Sociedad Anonima" />
        <meta
          name="twitter:description"
          content="Distribuidor autorizado YPF Gas en Salta"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://cn-grupo.com/gasdelnorte/" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Gas del Norte SA",
            image: "https://cn-grupo.com/LogoGasdelNorteSA.png",
            logo: "https://cn-grupo.com/LogoGasdelNorteSA.png",
            "@id": "https://cn-grupo.com/gasdelnorte/",
            url: "https://cn-grupo.com/gasdelnorte/",
            telephone: "+54 3874236555",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Avda.Chile 1275",
              addressLocality: "Salta",
              addressRegion: "Salta",
              postalCode: "4400",
              addressCountry: "AR",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: -24.804615680399422,
              longitude: -65.41651339151728,
            },
            taxID: "30-70823944-1",
          })}
        </script>
      </Helmet>
      <div className="video">
        <video autoPlay loop muted playsInline className="tuvideo">
          {/*<source src={videoSource1} type="video/mp4; codecs=av01" />
          <source src={videoSource} type="video/mp4" />*/}
          <source
            src="https://webcontent.cn-grupo.net/Media/Home%20Cn%20web%20v3%20.mp4"
            type="video/mp4; codecs=av01"
          />
          <source
            src="https://webcontent.cn-grupo.net/Media/Home%20Cn%20web%20v3%20.mp4"
            type="video/mp4"
          />
        </video>
        <div className="content">
          <div
            className="BarraEscritorio"
            style={{ position: "relative", zIndex: 10 }}
          >
            <NAVBAR></NAVBAR>
          </div>
          <div
            className="BarraMobile"
            style={{ position: "relative", zIndex: 10 }}
          >
            <NAVBARMOBILE></NAVBARMOBILE>
          </div>
          <div className="txt-redesHome">
            <div
              className="txt-container-empresaHome"
              style={{ position: "relative", zIndex: 10 }}
            >
              <h2 className="nuestra-empresa-txtHome">
                {t("nuestra-empresa-nuevo-txt.text1")}
                <span className="txt-empresa-spanHome">
                  {t("nuestra-empresa-nuevo-txt.text2")}
                </span>
                {t("nuestra-empresa-nuevo-txt.text3")}
                <br></br>
                {t("nuestra-empresa-nuevo-txt.text4")}
                <br></br>
                <span className="txt-empresa-spanHome">
                  {t("nuestra-empresa-nuevo-txt.text5")}
                </span>
                {t("nuestra-empresa-nuevo-txt.text6")}
                <br></br>
                {t("nuestra-empresa-nuevo-txt.text7")}
                <br></br>
                {t("nuestra-empresa-nuevo-txt.text8")}
                <br></br>
                {t("nuestra-empresa-nuevo-txt.text9")}
              </h2>
              <h2 className="nuestra-empresa-txtHomeMobile">
                {t("nuestra-empresa-nuevo-txt.text1")}
                <br></br>
                <span className="txt-empresa-spanHome">
                  {t("nuestra-empresa-nuevo-txt.text2")}
                </span>
                {t("nuestra-empresa-nuevo-txt.text3")}{" "}
                {t("nuestra-empresa-nuevo-txt.text4")}{" "}
                <span className="txt-empresa-spanHome">
                  {t("nuestra-empresa-nuevo-txt.text5")}
                </span>
              </h2>
            </div>
          </div>
          
          <div className="redes-container-empresa">
            <a
              href="https://www.linkedin.com/company/combustibles-del-norte-sa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="icono-red-social" />
            </a>
            <a
              href="https://www.instagram.com/cngrupo/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <RiInstagramFill className="icono-red-social" />
            </a>
            <a
              href="https://www.youtube.com/channel/UCBk3n8zBDz-0OkLbmszciLA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube className="icono-red-social" />
            </a>
            <a
              href="https://www.facebook.com/CNGRUPO"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook className="icono-red-social" />
            </a>
          </div>
        </div>
      </div>
      <div className="recuadros">
        <div className="imgResponsiva1">
          <div className="number">7</div>
          <span className="recuadros-span-number">
            {t("recuadros-span-nuevo.Leading companies")}
          </span>
          <br></br>
          {t("recuadros-span-nuevo.in their")}
          <br></br>
          {t("recuadros-span-nuevo.innovation and excellence")}
        </div>
        <hr class="mi-linea-ver"></hr>
        <div className="imgResponsiva1">
          <div className="number">+35</div>
          <span className="recuadros-span-number">
            {t("recuadros-span-nuevo.years of experience")}
          </span>
          <br></br>
          {t("recuadros-span-nuevo.in the")}
          <br></br>
          {t("recuadros-span-nuevo.fields of oil & gas")}
        </div>
        <hr class="mi-linea-ver"></hr>
        <div className="imgResponsiva1">
          <div className="number">12</div>{" "}
          <span className="recuadros-span-number">
            {t("recuadros-span-nuevo.operational bases")}
          </span>
          <br></br>
          {t("recuadros-span-nuevo.distributed in Salta")}
          <br></br>
          {t("recuadros-span-nuevo.northern Chile")}
        </div>
        <hr class="mi-linea-ver"></hr>
        <div className="imgResponsiva1">
          <div className="number">+240</div>{" "}
          <span className="recuadros-span-number">
            {t("recuadros-span-nuevo.collaborators")}
          </span>{" "}
          <br></br>
          {t("recuadros-span-nuevo.in constant")}
          <br></br>
          {t("recuadros-span-nuevo.professional growth")}
        </div>
      </div>

      <div className="containerfoto-cards">
        <div className="card-home">
          <img
            src={
              "https://webcontent.cn-grupo.net/Media/Fotos/Home/WEB_ IMAGEN 1.png"
            }
            alt="Oil&Gas"
          />
          <h2 className="title-card-home">Oil&Gas</h2>
          <p className="texto-card-home">
            {t("texto-card-home-nuevo.txt1")}
            <span className="txt-empresa-spanHome">
              {t("texto-card-home-nuevo.txt2")}
            </span>
            {t("texto-card-home-nuevo.txt3")}
            <span className="txt-empresa-spanHome">
              {t("texto-card-home-nuevo.txt4")}
            </span>
            {t("texto-card-home-nuevo.txt5")}
          </p>
          <hr class="mi-linea-home"></hr>
        </div>
        <div className="card-home">
          <img
            src={
              "https://webcontent.cn-grupo.net/Media/Fotos/Home/WEB_ IMAGEN 2.png"
            }
            alt="Agro"
          />
          <h2 className="title-card-home">Agro</h2>
          <p className="texto-card-home">
            {t("texto-card-home-nuevo.txt6")}
            <span className="txt-empresa-spanHome">
              {t("texto-card-home-nuevo.txt7")}
            </span>
            {t("texto-card-home-nuevo.txt8")}
          </p>
          <hr class="mi-linea-home"></hr>
        </div>
        <div className="card-home">
          <img
            src={
              "https://webcontent.cn-grupo.net/Media/Fotos/Home/WEB_ IMAGEN 3.png"
            }
            alt="Mineria"
          />
          <h2 className="title-card-home">{t("li.MINING")}</h2>
          <p className="texto-card-home">
            {t("texto-card-home-nuevo.txt9")}
            <span className="txt-empresa-spanHome">
              {t("texto-card-home-nuevo.txt10")}
            </span>
            {t("texto-card-home-nuevo.txt11")}
          </p>
          <hr class="mi-linea-home"></hr>
        </div>
      </div>
      <div className="my-carousel">
        <div className="txt-NuestraCultura-container">
          <h2 className="micarrusel-titulo">
            <span className="txt-NuestraCultura">{t("li.Our culture")}</span>
            <span className="txt-NuestraCultura1">{t("li.Our culture1")}</span>
          </h2>
          <p className="txt-NuestraCultura-txt">
            {t("txt-NuestraCultura.txt1")}
            <span className="txt-NuestraCultura-txt-span">
              {t("txt-NuestraCultura.txt2")}
            </span>
            {t("txt-NuestraCultura.txt3")}
            <span className="txt-NuestraCultura-txt-span">
              {t("txt-NuestraCultura.txt4")}
            </span>
            {t("txt-NuestraCultura.txt5")}
            <span className="txt-NuestraCultura-txt-span">
              {t("txt-NuestraCultura.txt6")}
            </span>
            {t("txt-NuestraCultura.txt7")}
          </p>
          <div className="img-NuestraCultura-botones">
            <a 
              href="https://www.canva.com/design/DAG_PMbuJD8/ChK_eDkYaFQfAUeWS8HVzA/view?utm_content=DAG_PMbuJD8&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hf6f5638e2e"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-NuestraCultura"
              style={{ textDecoration: 'none', display: 'inline-block' }}
            >
              {t("txt-NuestraCultura-Botones.txt1")}
            </a>
            <Link 
              to="/quienes"
              className="btn-NuestraCultura1"
              style={{ textDecoration: 'none', display: 'inline-block' }}
            >
              {t("txt-NuestraCultura-Botones.txt2")}
            </Link>
          </div>
        </div>
        <div className="img-NuestraCultura-container">
          <a
            href="https://www.youtube.com/@CN-Grupo/shorts"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', width: '100%' }}
          >
            <img
              src="https://webcontent.cn-grupo.net/Media/Fotos/Home/ImagenVideoPlay.png"
              alt="Video play button"
              style={{ width: '100%', height: 'auto', display: 'block' }}
            />
          </a>
        </div>
      </div>

      <div className="foot">
        <div className="Logos-empresa">
          <div className="Logos-empresa-top cartera-negocios">
            <div className="my-carousel-logos">
              <h2 className="micarrusel-titulo-logos">
                <span className="txt-NuestraCultura">{t("li.Our business portfolio")}</span>
                <span className="txt-NuestraCultura1">{t("li.Our business portfolio1")}</span>
              </h2>
            </div>
            <div className="Logos1 cartera-logos">
              {businessLogoRows.map((row, rowIndex) => (
                <div key={rowIndex} className="cartera-fila">
                  {row.map(({ href, src, alt }) => (
                    <div className="cartera-logo" key={alt}>
                      <a href={href} target="_blank" rel="noreferrer">
                        <img src={src} alt={alt} />
                      </a>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="Construyamos-Container">
            <div className="Construyamos-Container-Content">
            <div>
            <h2 className="txt-Titulo-Container">
            <span className="txt-Titulo-Construyamos">{t("txt-Construyamos.txt1")}</span>
            <span className="txt-Titulo-Construyamos1">{t("txt-Construyamos.txt2")}</span>
            </h2>
            <p className="txt-Texto-Container">
            <span className="txt-Texto-Construyamos">{t("txt-Construyamos.txt3")}</span>
            </p>
            </div>
            <div>
            <Homecomponente></Homecomponente>
            </div>
            </div>
            <div className="Logos-empresa-scroll">
            <div className="Scroll">
              <ScrollToTop
                smooth="false"
                color="white"
                className="scroll-to-top"
                style={{
                  borderRadius: "50%",
                  color: "white",
                  backgroundColor: "#5ABDCF",
                  border: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                }}
                component={
                  <img
                    src={FlechaScrol}
                    alt="Icono Personalizado"
                    style={{
                      width: 22,
                      height: 11,
                      top: "50%",
                      left: "50%",
                      transform: "translate(0%, -20%)",
                    }}
                  />
                }
              />
            </div>
          </div>
          </div>

          
          <div className="footer1">
            <div className="footer-left">
              <p className="txt-foo">{t("txt-foo2.Footer1")}</p>
            </div>
            <div className="footer-right">
              <div className="footer-right-left">
                <a 
                  href="https://webcontent.cn-grupo.net/Assets/Politica/CN-GRUPO_ Política de privacidad.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="txt-foo-politicas"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Politicas de privacidad
                </a>
              </div>
              <div className="footer-right-right">
                <p className="txt-foo2">{t("txt-foo2.Footer", { year: new Date().getFullYear() })}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
